import {useLayoutEffect, useState} from 'react'

export const useWindowWidth = () => {
    const [windowWidth, setWindowWidth] = useState(0)
    const updateWindowWidth = () => {
        setWindowWidth(window.innerWidth)
    }
    useLayoutEffect(() => {
        window.addEventListener('resize', updateWindowWidth);
        updateWindowWidth();
        return () => window.removeEventListener('resize', updateWindowWidth);
    },[])
    return windowWidth;
}